import { Device } from '@/store/device/types';
import { Prices } from '@/store/prices/types';

const isUSPricing = (prices: Prices | undefined | null, device: Device | undefined | null): boolean => {
	const currency = prices?.original?.currency;
	const yearly = prices?.original?.yearly;

	const isSupportedCountry = (prices?.original?.country?.toLowerCase() ?? device?.ip_country) === 'us';

	if (currency?.toLowerCase() === 'usd' && (yearly === 6999 || yearly === 7999) && isSupportedCountry) {
		return true;
	}
	return false;
};

export default isUSPricing;
